module.exports = __webpack_public_path__ + "img/pumpTruck-icon2.27e1ba99.png";